import { BUTTON_TYPES } from '@abiglobalhealth/go-types'
import { PropsWithChildren } from 'react'

import { cn } from '@/utils/tailwind'

const buttonVariant: Record<BUTTON_TYPES, string[]> = {
  [BUTTON_TYPES.PRIMARY]: ['bg-primary', 'text-white', 'bg-button-pattern', 'bg-cover', 'bg-no-repeat'],
  [BUTTON_TYPES.SECONDARY]: ['bg-primary-light', 'text-primary'],
  [BUTTON_TYPES.OUTLINED]: ['bg-white', 'text-primary', 'border', 'border-primary']
}

type ButtonProps = PropsWithChildren<{
  id?: string
  tabIndex?: number
  disabled?: boolean
  type?: BUTTON_TYPES
  onClick?: () => void
  customClassName?: string
  'data-testid'?: string
  custom?: boolean
  loading?: boolean
  hasShadow?: boolean
}>

export const Button = ({
  id,
  tabIndex,
  disabled,
  type = BUTTON_TYPES.PRIMARY,
  onClick,
  children,
  customClassName = '',
  'data-testid': dataTestId,
  custom,
  loading,
  hasShadow = true
}: ButtonProps) => {
  return (
    <button
      id={id}
      data-testid={dataTestId}
      tabIndex={tabIndex}
      disabled={disabled || loading}
      className={cn(
        'focus-within:outline-primary w-full rounded-lg px-5 py-4 text-base font-bold uppercase disabled:opacity-50',
        !custom && buttonVariant[type],
        hasShadow && 'shadow-sm',
        customClassName
      )}
      onClick={onClick}
    >
      {children}
    </button>
  )
}
